module.exports = __webpack_public_path__ + "static/media/secondary_logo_black.2a6487f7.png";